<template>
  <CFooter :fixed="false">
    <div>
      <a href="www.instabusinessgh.com" target="_blank">instabusinessgh</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} InstaBusiness. v2.01</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="www.newvifinancial.com">Prime Invest</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
